<template>
  <div class="p-20 bg-white">
    <div>
      <Button :loading="searching" @click="search" type="success" ghost>刷新列表</Button>
    </div>
    <div class="p-t-15">
      <span class="c-red">注：您只能看到法定代表人或经办人预留手机号与您绑定手机相同的推送</span>
    </div>
    <div class="p-t-15">
      <Table :columns="columns" border :data="dataPages.content"></Table>
      <div class="text-r p-15">
        <Page :total="dataPages.totalElements" :current="dataPages.number+1" show-elevator show-total
              :page-size="20" size="small" @on-change="search"></Page>
      </div>

      <Modal v-model="detailModal.show" title="工商推送详情" cancel-text="" ok-text="关闭">
        <Group>
          <Cell title="信用代码：" :value="dataCurrent.orgUscc"></Cell>
          <Cell title="企业名称：" :value="dataCurrent.orgName"></Cell>
          <Cell title="注册地址：" :value="dataCurrent.orgAddress"></Cell>
          <Cell title="法定代表人姓名：" :value="dataCurrent.crpName"></Cell>
          <Cell title="法定代表人证件号：" :value="dataCurrent.crpCertNo"></Cell>
          <Cell title="法定代表人电话：" :value="dataCurrent.crpPhone"></Cell>
          <Cell title="经办人姓名：" :value="dataCurrent.opName"></Cell>
          <Cell title="经办人证件号：" :value="dataCurrent.opCertNo"></Cell>
          <Cell title="经办人电话：" :value="dataCurrent.opPhone"></Cell>
          <Cell title="选定门店：" :value="dataCurrent.aicMaker.name" v-if="dataCurrent.aicMaker" class="b-t-1 m-t-5"></Cell>
          <Cell title="地址：" :value="dataCurrent.aicMaker.address" v-if="dataCurrent.aicMaker"></Cell>
          <Cell title="联系电话：" :value="dataCurrent.aicMaker.phone" v-if="dataCurrent.aicMaker"></Cell>

        </Group>
      </Modal>
    </div>
  </div>
</template>

<script>
  import {mixinPages} from '@tubo/tubo-base/mixins'
  import {api, http} from '@/libs'

  export default {
    mixins: [mixinPages],
    data() {
      return {
        columns: [
          {title: '信用代码', maxWidth: 200, key: 'orgUscc'},
          {title: '单位名称', key: 'orgName'},
          {title: '推送时间', maxWidth: 160, key: 'dateUpdate'},
          {
            title: "使用状态", maxWidth: 90,
            render: (h, w) => h('span', {
              directives: [{
                name: 'dict',
                value: w.row.usageState,
                arg: 'EntityGzwAic_usageState'
              }]
            })
          },
          {
            title: '操作',
            width: 250,
            render: (h, w) => {
              let that = this
              const buttons = []
              buttons.push(
                h('Button', {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      this.detailModal.show = true;
                      this.dataCurrent = w.row
                    }
                  }
                }, '查看'))

              if (w.row.usageState==="0") {
                buttons.push(h("Button", {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      that.$router.push({path: '/custom/reservation/new', query: {id: w.row.id}})
                    }
                  }
                }, "免费刻章"))

                buttons.push(h("Button", {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      that.$Modal.confirm({
                        title: "网上下单",
                        content: "网上下单后, 其他用户或刻章企业将无法通过此推送办理, 请生成后完成填报并在线付款",
                        onOk() {
                          that.importAic(w.row.id)
                        }
                      });
                    }
                  }
                }, "网办"))

                buttons.push(h("Button", {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      that.takeOffline(w.row)
                    }
                  }
                }, "门店"));
              }

              if (w.row.usageState==="2") {
                buttons.push(h("Button", {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      that.$Modal.confirm({
                        title: "撤销门店办理",
                        content: "撤销后您可以重新选择网上下单或门店办理",
                        onOk() {
                          _this.takeReset(w.row.id)
                        }
                      });
                    }
                  }
                }, "撤销门店办理"));
              }
              return buttons
            }
          }
        ],
        detailModal: {
          show: false
        }
      }
    },
    computed: {
    },
    methods: {
      importAic(aicId) {
        http.post(api.gzwCusOrder.importAic, {aicId: aicId}).then(() => {
          this.$router.push('/custom/order/current')
        })
      },
      takeOffline(aic) {
        this.$store.commit('order/SET_CURRENT_AIC', aic)
        this.$router.push('/custom/samr/offline')
      },
      takeReset(aicId) {
        http.post('/api.cus/v1/gzw/cus/aic/reset', {aicId: aicId}).then(payload => {
          this.changeCurrent(payload)
        })
      },
      reservation(id) {
        this.$router.push({path: '/custom/reservation/new', query: {id: id}})
      },
    },
    created() {
      this.searchApi = api.gzwCusOrder.aic
    }
  }
</script>
